import idx from 'idx'
import { subDays } from 'date-fns'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { animateScroll } from 'react-scroll'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import { DATE_DROPDOWN_DEFAULT } from 'constants/tables'
import { isEqual, getPaginationObject } from 'utils/misc'

import * as mapModule from 'modules/map'
import * as trapModule from 'modules/trap'
import * as popoverModule from 'modules/popover'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

export default compose(
  connect(
    (state) => {
      return {
        traps: idx(state, _ => _.traps.items),
        tableLoading: idx(state, _ => _.traps.loading),
        group: idx(state, _ => _.groups.selected) || {},
        organisation: idx(state, _ => _.organisation.selected)
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
        ...trapModule,
        ...userActions,
        ...routeActions,
        ...popoverModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      selectedRange: DATE_DROPDOWN_DEFAULT,
      filters: {
        dateLimit: subDays(new Date(), DATE_DROPDOWN_DEFAULT.value),
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onRangeChange: state => selectedRange => ({
        ...state,
        selectedRange,
        filters: {
          ...state.filters,
          dateLimit: subDays(new Date(), selectedRange.value),
          loaded: false,
        }
      }),
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
      onSearchChange: ({setFilters}) => (value) => {
          setFilters({search: [{key: 'trapName', value}]})
      },
      onTableRowClick: ({actions}) => (row) => {
          actions.selectTrap(row, () => {
              actions.showPopover(popoverModule.TRAP_DETAILS)
          })
      },
      onTableSortClick: ({setFilters}) => (orderBy) => {
          setFilters({orderBy: [orderBy]})
      },
      onTableSelectableClick: ({actions}) => (selectable) => {
          animateScroll.scrollTo(250, {duration: 500})
          setTimeout(() => {
              actions.focusTrap(selectable)
      }, 500)
    }
  }),
  lifecycle({
    componentDidMount() {
      const { 
        actions, organisation, group, filters, setPagination
      } = this.props

      window.scroll(0, 0)
      actions.getGroupTraps(organisation, group, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const {
        actions, organisation, group, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getGroupTraps(organisation, group, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/groups/GroupDataDetail/GroupDataDetail.enhancer.js